export const SET_EO_ID = 'SET_EO_ID'
export const SET_CLASSES = 'SET_CLASSES'
